import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetIncidentPerStandsInputDto, IncidentPerStandCreateDto, IncidentPerStandDto, IncidentPerStandExcelDownloadDto, IncidentPerStandUpdateDto } from '../dtos/incident-per-stand/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class IncidentPerStandService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: IncidentPerStandCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentPerStandDto>({
      method: 'POST',
      url: '/api/operational/incidentPerStands',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/incidentPerStands/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/incidentPerStands',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentPerStandDto>({
      method: 'GET',
      url: `/api/operational/incidentPerStands/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/incidentPerStands/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetIncidentPerStandsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IncidentPerStandDto>>({
      method: 'GET',
      url: '/api/operational/incidentPerStands',
      params: { incidentId: input.incidentId, incidentName: input.incidentName, incidentTypeId: input.incidentTypeId, rotationId: input.rotationId, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: IncidentPerStandExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/incidentPerStands/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, incidentId: input.incidentId, incidentName: input.incidentName, incidentTypeId: input.incidentTypeId, rotationId: input.rotationId, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentPerStandDto[]>({
      method: 'GET',
      url: '/api/operational/incidentPerStands/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: IncidentPerStandUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentPerStandDto>({
      method: 'PUT',
      url: `/api/operational/incidentPerStands/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}